<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="titlepage">
<figure class="TIT" id="tit"><img alt="The Wound and The Bow by Edmund Wilson" class="img90" src="images/title.jpg"/>
</figure>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?e803abd8